$(function() {
    "use strict";

    /**
     * Datepicker.
     */
    datepicker();

    /**
     * Sidebar.
     */
    initSidebar();
    $(window).on("resize", resizeSidebar);
});
